<div class="menu-image-box" [ngClass]="{ 'required': showRequired, 'loading-state': isLoadingThumbnail }" (click)="handleContainerClick($event, fileInput)">
    <div *ngIf="autoResized">
        <ul>
            <li>{{ 'catalog.common.adjustImageHint' | translate }}</li>
            <li>{{ 'catalog.common.cropImageHint' | translate }}</li>
        </ul>
    </div>
    <div class="thumbnail-container" *ngIf="showThumbnail && (thumbnail || isLoadingThumbnail)">
        <txp-loading *ngIf="isLoadingThumbnail" [color]="loadingColor.COLOR"></txp-loading>
        <img *ngIf="!isPdf && thumbnail" [src]="thumbnail" [hidden]="isLoadingThumbnail" (load)="onImageLoad()" (error)="onImageError()" alt="Thumbnail"/>
        <embed *ngIf="isPdf && thumbnail" [src]="thumbnail" [hidden]="isLoadingThumbnail" type="application/pdf" width="100%" height="400px"/>
    </div>
    <div class="file-actions" [hidden]="isLoadingThumbnail">
        <form #form ngNoForm class="grid-item">
            <label class="image-upload" [ngClass]="{'disabled': disableFileUpload}">
                {{ label }}
                <input #fileInput type="file"
                       class="hidden"
                       [accept]="accept"
                       [disabled]="disableFileUpload"
                />
            </label>
        </form>
        <label *ngIf="showCrop && !isPdf && thumbnail"
               (click)="onOpenCropImage()"
               [attr.title]="'catalog.common.cropImage' | translate"
               data-qa-label="CropButton"
               class="grid-item">
            {{ 'catalog.common.cropImage' | translate }}
        </label>
        <txp-button icon="tce-icon-undo"
                    class="btn-undo grid-item"
                    *ngIf="showResize && resized && fileValue"
                    (click)="undoResize()"
                    [style]="buttonStyle.ROWACTION"
                    [attr.title]="'form.button.undo' | translate">
        </txp-button>
        <txp-button icon="tce-icon-trash"
                    class="btn-trash grid-item"
                    *ngIf="thumbnail && showRemove"
                    (click)="handleDelete()"
                    [style]="buttonStyle.ROWACTION">
            <span class="hidden">{{ 'form.button.remove' | translate }}</span>
        </txp-button>
    </div>
</div>
